import { Bot, headerBot } from '../bots';
import Base from './Base';

export interface ApiAuthResponse {
    user: User | null;
    audiences: string[] | null;
    visitorId: string | null;
    bot?: Bot | null;
    isNew?: boolean;
}

class Auth extends Base {
    check(query = null, opts?: RequestInit) {
        return this.isBot
            ? Promise.resolve({
                  user: null,
                  consent: true,
                  visitorId: 'bot',
                  bot: headerBot,
              })
            : this.getJSONWithSession<ApiAuthResponse>('/check', query, opts);
    }

    sendToken(data, opts?: RequestInit) {
        return this.postJSONWithSession<{ success: boolean }>('/send-token', data, opts);
    }

    providerLogin(provider: string, data, opts?: RequestInit) {
        return this.postJSONWithSession<ApiAuthResponse>(`/${provider}/login`, data, opts);
    }

    login(data, opts?: RequestInit) {
        return this.postJSONWithSession<ApiAuthResponse>('/login', data, opts);
    }

    logout(opts?: RequestInit) {
        return this.getJSONWithSession<ApiAuthResponse>('/logout', null, opts);
    }

    identify(data, opts?: RequestInit) {
        return this.postJSONWithSession<ApiAuthResponse>('/identify', data, opts);
    }
}

export default Auth;
